import { Component, OnInit, Input } from '@angular/core';
import { SafeUrl, DomSanitizer } from '@angular/platform-browser';
import { AppConfigService } from '../../../app-config.service';
import { CONSEIL_URL_GOUV_FR, CONSEIL_URL_GOUV_EN } from '../../../../configs/urls.config';

@Component({
  selector: 'app-capsule-conseil-reduce',
  templateUrl: './capsule-conseil-reduce.component.html',
  styleUrls: ['./capsule-conseil-reduce.component.scss'],
  standalone: false
})
export class CapsuleConseilReduceComponent implements OnInit {
  @Input()
  textConseil: string;

  @Input()
  linkTitle: string;

  @Input()
  linkLabelSR: string = null;

  safeUrl: SafeUrl;
  externalUrl: string;
  constructor(private readonly domSanitizer: DomSanitizer, private readonly appConfigService: AppConfigService) {}

  ngOnInit() {
    this.externalUrl =
      this.appConfigService.configData.contexteEnvironnement.langue === 'fr'
        ? CONSEIL_URL_GOUV_FR
        : CONSEIL_URL_GOUV_EN;
    if (this.appConfigService.configData.contexteEnvironnement.app) {
      this.safeUrl = this.domSanitizer.bypassSecurityTrustUrl('smdesj://web?' + this.externalUrl);
    } else {
      this.safeUrl = this.domSanitizer.bypassSecurityTrustUrl(this.externalUrl);
    }
  }
}
